// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","imageWrapper":"Card_imageWrapper__K3vID","chip":"Card_chip__agKFm","title":"Card_title__A6GVy"};